import { Clipboard } from '@angular/cdk/clipboard';
import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { EventType } from '@app/core/enums/meta.enum';
import { ApiResponse } from '@app/core/models/api-response.model';
import { Analytics } from '@app/core/services/analytics/analytics.service';
import { ToasterService } from '@app/core/services/toaster.service';
import { Referral } from '@app/core/interfaces';
import { CouponService } from '@app/pages/shared/services/coupon.service';
import { environment } from '@environments/environment';
import { Subject, takeUntil } from 'rxjs';
import { AppConstant } from '@app/core/constant/app-constant';

@Component({
  selector: 'app-share-referral',
  templateUrl: './share-referral.component.html',
  styleUrl: './share-referral.component.scss',
})
export class ShareReferralComponent implements OnInit, OnDestroy {
  @Output() closeModals = new EventEmitter<boolean>(false);
  unSubscribeAll: Subject<void> = new Subject<void>();
  sharingURL: string = '';

  sharingPlatforms: Array<string> = [
    'whatsapp',
    'email',
    'sms',
    'telegram',
    'facebook',
    'linkedin',
    'x',
  ];

  referral: Referral = {
    title: null,
    referralCode: null,
    content: null,
  };

  copied: boolean = false;

  private readonly DIALOG = 'Share Referral';

  constructor(
    private readonly clipboard: Clipboard,
    private readonly toaster: ToasterService,
    private readonly couponService: CouponService,
    private readonly analytics: Analytics
  ) {}

  ngOnInit(): void {
    this.couponService
      .fetchReferralCode()
      .pipe(takeUntil(this.unSubscribeAll))
      .subscribe({
        next: (res: ApiResponse<Referral>) => {
          this.referral = res.data;
        },
        error: (error: any) => {
          console.error(error.message);
          if (error.status !== AppConstant.PORT.Forbidden)
            this.toaster.error(error.message);
        },
      });
    this.sharingURL = environment.hostUrl;
    this.analytics.dialogOpen(this.DIALOG);
  }

  closeModal(): void {
    this.closeModals.emit();
  }
  copyReferralCode() {
    this.copied = true;
    let isDataCopied = this.clipboard.copy(
      this.referral.content ?? 'Referral Code is not available.'
    );
    if (isDataCopied) {
      this.toaster.success('toaster.Text Successfully copied to clipboard.');
      this.analytics.customAnalytics('Referral Code Copy', {
        code: this.referral.referralCode,
        page: this.DIALOG,
        eventType: EventType.click,
      });
      setTimeout(() => {
        this.copied = false;
      }, 4000);
    } else {
      this.toaster.error('toaster.Unable to copy the referral code.');
      this.analytics.failureEvent('Referral Code Copy Failure', {
        error: 'Clipboard Error',
        reason: 'Can not copy data, due to clipboard error',
        page: this.DIALOG,
        eventType: EventType.generalError,
      });
    }
  }

  shareLog(platform: any) {
    this.analytics.customAnalytics('Share Referral Click', {
      platform,
      code: this.referral.referralCode,
      page: this.DIALOG,
      eventType: EventType.click,
    });
  }

  ngOnDestroy(): void {
    this.unSubscribeAll.next();
    this.analytics.pageExit();
  }
}
